import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { services } from "data/services";

const TechnicalExpertise = () => {
  const [activeCategory, setActiveCategory] = useState("visualProduction");

  const [showQuickNav, setShowQuickNav] = useState(false);

  const expertiseCategories = {
  visualProduction: mapService("visual-production", "Film"),
  branding: mapService("strategic-branding", "Palette"),
  digitalPresence: mapService("digital-presence", "Globe"),
  socialMedia: mapService("social-media", "Share2"),
  campaigns: mapService("campaign-engineering", "Megaphone"),
};

function mapService(id, icon) {
  const s = services.find(x => x.id === id);

  return {
    title: s.title,
    icon,
    image: s.image,
    color: s.color,
    description: s.shortdescription || s.description,
    skills: s.skills
  };
}



  const certifications = [
    {
      title: "FAA Part 107 Remote Pilot",
      issuer: "Federal Aviation Administration",
      date: "2023",
      icon: "Award",
      description: "Commercial drone operations certification"
    },
    {
      title: "RED Camera Certified",
      issuer: "RED Digital Cinema",
      date: "2022",
      icon: "Camera",
      description: "Advanced RED camera operation and workflow"
    },
    {
      title: "DaVinci Resolve Certified",
      issuer: "Blackmagic Design",
      date: "2023",
      icon: "Palette",
      description: "Professional color grading certification"
    },
    {
      title: "Safety Training Certified",
      issuer: "OSHA",
      date: "2023",
      icon: "Shield",
      description: "Workplace safety and risk management"
    }
  ];

  return (
    <>
      <div data-theme="light" className="space-y-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:space-y-12 mb-8">
        {/* Section Header */}
        <div className="text-center max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-2">
            Technical <span className="text-red-600">Expertise</span>
          </h2>
          <p className="text-base sm:text-xl text-text-secondary">
            Mastery of cutting-edge technology and systematic approaches that ensure consistent,
            professional results for every corporate project.
          </p>
          <div className="block sm:hidden">
            <button
              onClick={() => setShowQuickNav(true)}
              className="  mt-4 inline-flex items-center gap-2 bg-accent text-white px-5 py-2 rounded-md text-sm font-semibold"
            >
              Select Expertise Area
              <Icon name="ChevronUp" size={16} />
            </button>
          </div>
        </div>
        {/* Category Navigation */}
        <div className="max-w-7xl mx-auto mb-12 px-1">
          <div className="hidden sm:flex gap-4 overflow-x-auto md:justify-center scrollbar-hide">
            {Object.entries(expertiseCategories).map(([key, category]) => {
              const isActive = activeCategory === key;

              return (
                <button
                  key={key}
                  onClick={() => setActiveCategory(key)}
                  className={`flex items-center gap-2 px-2 py-2 rounded-xl font-semibold whitespace-nowrap transition-all
            ${isActive
                      ? 'bg-accent text-white shadow-elevation'
                      : 'bg-surface text-text-primary hover:bg-accent/10 hover:text-accent'}
          `}
                >
                  {/* <Icon name={category.icon} size={20} strokeWidth={2} /> */}
                  <span>{category.title}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Active Category Content */}
        <div className="grid lg:grid-cols-2 gap-2 sm:gap-8 items-start">
          {/* Skills Breakdown */}
          <div className="space-y-2 md:space-y-8">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-red-600 mb-2">
                {expertiseCategories[activeCategory].title}
              </h3>
              <p className="text-text-secondary text-base mb-4">
                {expertiseCategories[activeCategory].description}
              </p>
            </div>

            <div className="space-y-6">
              {expertiseCategories[activeCategory].skills.map((skill, index) => (
                <div key={index} className="space-y-3">
                  <div className="flex justify-between items-center">
                    <h4 className="font-semibold text-primary">{skill.name}</h4>
                    <span className="text-accent font-bold">{skill.level}%</span>
                  </div>
                  <div className="w-full bg-border rounded-full h-2">
                    <div
                      className="bg-gradient-to-r from-accent to-accent-bright h-2 rounded-full cinematic-transition"
                      style={{ width: `${skill.level}%` }}
                    />
                  </div>
                  <p className="text-sm text-text-secondary">{skill.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Content */}
         <div className="hidden sm:block relative w-full h-[220px] sm:h-[300px] md:h-[360px] lg:h-[420px] rounded-xl overflow-hidden shadow-elevation">

            <Image
              src={`${expertiseCategories[activeCategory].image}?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80`}
              alt={expertiseCategories[activeCategory].title}
              className="w-full h-full object-cover"
            />
            <div className={`absolute inset-0 bg-gradient-to-t ${expertiseCategories[activeCategory].color} opacity-80`} />
          </div>
        </div>

        {/* Certifications Section */}
        {/* <div className=" rounded-2xl p-8 md:p-12">
        <h3 className="text-3xl font-bold text-primary mb-8 text-center">
          Professional Certifications
        </h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-subtle hover-lift text-center">
              <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={cert.icon} size={24} color="var(--color-accent)" strokeWidth={2} />
              </div>
              <h4 className="font-bold text-primary mb-2">{cert.title}</h4>
              <p className="text-sm text-text-secondary mb-2">{cert.issuer}</p>
              <p className="text-xs text-accent font-semibold mb-3">{cert.date}</p>
              <p className="text-xs text-text-secondary">{cert.description}</p>
            </div>
          ))}
        </div>
      </div> */}

        {/* Technical Philosophy */}
        <div className="bg-black-red-oscillate text-white rounded-2xl p-6 sm:p-8 text-center border-l-8 border-accent">
          <Icon name="Lightbulb" size={48} className="mx-auto text-accent mb-2 sm:mb-4" strokeWidth={1.5} />
          <h3 className="text-xl sm:text-2xl text-white/90 font-bold mb-2 sm:mb-4">Engineering Excellence</h3>
          <p className="text-base sm:text-lg text-white/90 max-w-3xl mx-auto">
            "Technical mastery isn't about having the most expensive equipment—it's about understanding
            every tool in your arsenal and knowing exactly when and how to use each one to serve the story.
            Every technical decision should be invisible to the audience but essential to the impact."
          </p>
        </div>
      </div>
      <div className="fixed inset-0 z-[9999] lg:hidden pointer-events-none">
        <aside
          className={`
      pointer-events-auto
      absolute inset-x-0 bottom-0
      bg-white
      rounded-t-3xl
      shadow-2xl
      transition-transform duration-300
      ${showQuickNav ? 'translate-y-0' : 'translate-y-full'}
    `}
        >
          <div className="p-4">
            {/* Drag Handle */}
            <div className="flex justify-center mb-3">
              <div className="h-1.5 w-12 bg-gray-300 rounded-full" />
            </div>

            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <span className="font-semibold text-sm text-primary">
                Select Expertise Area
              </span>
              <button
                onClick={() => setShowQuickNav(false)}
                className="text-sm text-text-secondary"
              >
                Close
              </button>
            </div>

            {/* List */}
            <div className="space-y-2 max-h-[60vh] overflow-y-auto">
              {Object.entries(expertiseCategories).map(([key, category]) => {
                const isActive = activeCategory === key;

                return (
                  <button
                    key={key}
                    onClick={() => {
                      setActiveCategory(key);
                      setShowQuickNav(false);
                    }}
                    className={`w-full flex items-center gap-3 p-3 rounded-lg text-left transition
                ${isActive
                        ? 'bg-accent/10 text-accent'
                        : 'hover:bg-surface'}
              `}
                  >
                    <Icon name={category.icon} size={18} />
                    <span className="font-medium">{category.title}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </aside>
      </div>
    </>
  );
};

export default TechnicalExpertise;